/**
 * @author xiaohuangmaoth
 * @description 查看受众层组件
 * @Date 2020/1/20
 */
import React from "react";
import PropTypes from "prop-types";
import { component_tool } from "@/tool";
import "./index.less";

const { WizComponent, WizModal, WizRow, WizCol, WizAlert } = component_tool;
export default class AudienceGroupItem extends WizComponent {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
    };
  }

  handleClick = () => {
    this.setState({ visible: true });
  };

  render() {
    const { isModal, btnText, ...other } = this.props;
    const { visible } = this.state;

    const modalProps = {
      visible,
      title: "查看受众",
      footer: null,
      onCancel: () => { this.setState({ visible: false }) },
    };

    return isModal ? (
      <React.Fragment>
        <a className="link" onClick={this.handleClick}>{btnText || "查看受众"}</a>
        <WizModal {...modalProps}>
          <Content {...other} />
        </WizModal>
      </React.Fragment>
    ) : (
      <Content {...other} />
    );
  }
}

AudienceGroupItem.defaultProps = {
  isModal: false, // 是否模态框展示
  btnText: "查看", // 按钮文字
  orgIds: [],
  personIds: [],
  positionCategoryIds: [],
  positionIds: [],
};

AudienceGroupItem.propTypes = {
  isModal: PropTypes.bool,
  btnText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  orgIds: PropTypes.array,
  personIds: PropTypes.array,
  positionCategoryIds: PropTypes.array,
  positionIds: PropTypes.array,
};
_renderMessage = (message) => {
  if (message && message.length) {
    let messageIntem = message.map((val, index) => (
      <div key={index} className="message-item">
        {val}
      </div>
    ));
    return (
      <div className="authority-show">
        <div className="block-item">
          <WizRow type="flex" justify="center">
            <WizCol span={18}>
              <WizAlert message={messageIntem} type="info" showIcon />
            </WizCol>
          </WizRow>
        </div>
      </div>
    );
  }
};
function Content({ isAll, orgIds, personIds, positionCategoryIds, positionIds, message, showMessage }) {
  const arr = [
    { title: "组织选择", value: orgIds },
    { title: "岗位分类", value: positionCategoryIds },
    { title: "岗位选择", value: positionIds },
    { title: "指定人员", value: personIds },

  ];

  const filterArr = arr.filter((val) => val.value && val.value.length);
  let constItem = []
  if (filterArr.length) {
    constItem.push(arr.map((val, index) =>
      val.value && val.value.length ? (
        <div className="audience-group-value" key={index}>
          <div className="audience-group-value__title">{val.title}：</div>
          <div className="audience-group-value__value">
            {val.title === "指定人员"
              ? val.value.map((val, index) => (
                <span key={index}>
                  {val.fullName}({val.userName})
                </span>
              )) 
              : val.title === "组织选择" ?
              val.value.map((val, index) => (
                // <p style={{wordBreak: "break-all"}}>
                 <p key={index}>{val.name}</p>
                  // {/* </p> */}
              ))
              : val.value.map((val, index) => (
                <span key={index}>{val.positionBrandName ? val.positionBrandName : val.name }</span>
              ))}
          </div>
        </div>
      ) : null
    ))
  } else if (isAll==1) {
    constItem.push(<div className="audience-group-value" >
      <div className="audience-group-value__title">指定人员：</div>
      <div className="audience-group-value__title">
        <span>所有人</span>
      </div>
    </div>)
  }
  if (showMessage && message) {
    constItem.push(this._renderMessage(message))
  }
  return (filterArr.length || isAll==1)
    ? constItem : "暂无";
}
